<!--
@touchstart="subnavHover($event)"
@mouseover="subover"
-->

<template>
    <div class="sort-nav-menu backdrop">
        <div class="nav-wrap">
            <div><span>SORT BY:</span></div>
            <div>
                <ul ref='categories' class="categories">
                    <li class="parent" v-for="category in categories" :key="category.name" >

                        <!--
                         <router-link class="parent-link" :to="{ name: 'results-root', params: { category: category.name } }">
                            <img class="parent-icon" :src="category.src" :alt="category.name">
                            <span class="parent-label" v-text="category.name"></span>
                        </router-link>
                        -->

                        <button class="parent-link" @click="openCategory(category)">
                            <img class="parent-icon" :src="category.src" :alt="category.name">
                            <span class="parent-label" v-text="category.name"></span>
                        </button>
                        

                        <ul class='subnav' v-if="hasChildren(category)" @mouseenter="subnavHover($event)" @mouseleave="subnavOut($event)" @touchstart="subnavHover($event)">
                            <li class="parent" v-for="child in category.children" :key="child.name">
                                <router-link :to="{ name: 'results-child', params: { rootFilter: category.name, subcat: child.name } }">
                                    <span>{{child.name}}</span>
                                </router-link>
                                <ul class='grandsubnav' v-if="hasChildren(child)" @mouseenter="subnavHover($event)" @mouseleave="subnavOut($event)"  @touchstart="subnavHover($event)">
                                    <li v-for="grandchild in child.children" :key="grandchild.name">
                                        <router-link :to="{ name: 'results-grandchild', params: { rootFilter: category.name, subcat: child.name, grandchildFilter: grandchild.name } }">
                                            <span>{{grandchild.name}}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>

                <div class="mobileSignout">
                    <button class="sign-out" id="signout2" @click="signout">Sign Out</button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { mapState,mapActions } from 'vuex';

export default {
    data() {
        return {
            categoriesEl: null
        }
    },
    mounted() {
        window.addEventListener("resize", this.setScreen);
        this.initDomRefs();
        this.setScreen();
    },
    destroy() {
        // console.log('sortmenu destroyed');
        window.removeEventListener("resize", this.setScreen, false);
    },
    methods: {
		...mapActions([
			'userSignout'
		]),
        signout()
        {
            this.userSignout();
        },
        initDomRefs() {
            let int = setInterval(function() {
                if (!!this.$refs && !!this.$refs.categories) {
                    this.categoriesEl = this.$refs.categories.$el;
                }
            }.bind(this), 300)
        },
        openCategory(category)
        {
            //:to="{ name: 'results-root', params: { rootFilter: category.name } }
            //alert(category.name);
            //router.push({ name: 'results-root', params: { rootFilter: category.name }})
            //this.$router.push({ name: 'results-search', params: { searchFilter: this.searchval }})
            this.$router.push({ name: 'results-root', params: { category: category.name }})

        },
        setScreen() {

            let wrap = this.$el;
            // console.log('set screen >> ', wrap);
            window.scrollTo(0, 0);
            setTimeout(function () {
                let vpheight = window.innerHeight; //Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                wrap.style.height = (vpheight - 129) + "px";
            }, 200)
        },
        hasChildren(cat) {
            return _.has(cat, 'children');
        },
        subover(e)
        {
            //let _parent = e.target.closest('.parent');
            //alert("_parent="+_parent.classList[0]);

            //if (e.type=="touchstart" && !!_parent && ! _parent.classList.contains('active')) {
                //e.preventDefault();
                //if (_parent.parentNode.classList.contains('categories')) {
                  //  catParents.forEach(el => el.classList.remove('active'))
                //}
                //_parent.classList.add('active')
            //}
        },
        subnavHover(e) {
            let _parent = e.target.closest('.parent');
            // parents = document.querySelector('.categories').querySelectorAll('.parent');
            if (e.type=="touchstart" && !!_parent && ! _parent.classList.contains('active')) {
                e.preventDefault();
                /*
                if (_parent.parentNode.classList.contains('categories')) {
                    catParents.forEach(el => el.classList.remove('active'))
                }
                _parent.classList.add('active')
                */
            }
        },
        subnavOut(el) {
            el.target.classList.remove('active')
        }
    },
    computed: {
        catParents() {
            let cats = this.categoriesEl;
            return cats.querySelectorAll('.parent');
        },
        ...mapState([
            'categories'
        ])
    }
}
</script>
<style lang="stylus">
@import '~settings';
@import '~rupture';

.mobileSignout
    display none
    .sign-out
        display inline-block
        vertical-align middle
        color #fff
        opacity 0.7
        border-top solid 1px #fff
        padding-top 20px
        margin-top 20px
        width 100%
        text-align left
    +below(850px)
        display block


.sort-nav-menu
    // padding-top 10vh
    // padding-bottom 10vh
    padding 0 !important
    height 87vh
    +below(1024px)
        height 84vh
    .nav-wrap
        position absolute
        width 100%
        height 80%
        top 50%
        transform translate(0, -50%)
        +below(815px)
            top 0px
            transform none
        & > :first-child
            +below(815px)
                display none
            position absolute
            height 100%
            width 30%
            left 0
            span
                position absolute
                top 50%
                right 0
                transform translate(0, -50%)
                padding-right 46px
                font-size 27px
                color rgba(#fff, 0.8)
        & > :last-child
            +below(815px)
                left 0px
            position absolute
            left 30%
            top 50%
            transform translateY(-50%)
            height auto
            border-left 1px solid #474849
            padding-left 30px
    .categories
        padding 50px 0 0 0
        margin 0
        float left
        backface-visibility hidden
        & li
            backface-visibility hidden
            cursor pointer
            list-style none
            padding 0
            margin-bottom 12px
            opacity 0.5
            transition opacity 200ms ease-out
            position relative
            width 136%
            &:hover
                opacity 1
            +below(1024px)
                width 125%
            +below(815px)
                opacity 1
            a
                display block
            img
                width 8vmin //99px
                height @width //99px
                margin-right 40px
                vertical-align middle
                display inline-block
                +below(815px)
                    margin-right 20px
            span
                vertical-align middle
                display inline-block
                color #dfdfdf
                font-size 24px
                transition color 200ms ease
                +below(815px)
                    font-size 18px
                    color #fff                
            ul
                transform translate3d(0,0,0)
                transform translateY(100%)
                opacity 0
                padding 0
                position absolute
                list-style none
                top 70%
                left 70%
                padding-right 5%
                padding-left 20%
                transition transform 150ms ease-out-quint, opacity 150ms ease-out-quint
                z-index 999
                li
                    margin-bottom 2vmin
                    span
                        fontsizer(14px, 22px, 1024px, 1900px)
                &.grandsubnav
                    top 0
                    width 120%
                    left 105%
                    li
                        margin-bottom 1vmin
                        a span
                            fontsizer(16px, 20px)
                &.active
                    transform translateY(0)
                    opacity 1
            +below(815px)
                color #fff
            &:hover,
            &.active,            
                opacity 1
                span
                    color #fff
                & > ul
                    transform translateY(-25%)
                    opacity 1
                    &.grandsubnav
                        transform translateY(0)
</style>